import styles from 'css/Nav.module.css'
import { NavLink, useLocation } from 'react-router-dom'
import { AnimatePresence, motion } from 'framer-motion'
import { useEffect, useState, useRef } from 'react'

const Nav = ({ show }) => {

	const location = useLocation()
	const [activeNav, setActiveNav] = useState()
	const nav = useRef()

	const variants = {
		initial: {
			bottom: -88
		},
		animate: {
			bottom: 0
		}
	}

	const setNav = () => {
		// setActiveNav(location.pathname.match(/(?<=^\/)(.*?)(?=\/|$)/)[0])
		const match = location.pathname.match(/\/.*\//)
		if (match) {
			const active = match[0].replace(/\//g, "")
			setActiveNav(active)
		} else {
			setActiveNav()
		}
		const a = document.querySelector("nav .active")
		if (!a) return

		console.log("Nav 상태:", document.querySelector("nav .active"));
		const rect = a.getBoundingClientRect()
		const x = rect.x
		const computedStyle = window.getComputedStyle(a)
		const width = rect.width - Number(computedStyle.paddingLeft.replace(/px/, "")) - Number(computedStyle.paddingRight.replace(/px/, ""))
		nav.current.style.backgroundPositionX = `${x + (width / 2)}px`
	}

	useEffect(() => {
		setNav()
	}, [location.pathname])

	useEffect(() => {
		if (show) setNav()
	}, [show])

	return (
		<AnimatePresence>
			{show &&
				<motion.nav ref={nav} variants={variants} initial="initial" animate="animate" exit="initial" className={`${styles.Nav} ${activeNav}`}>
					<NavLink to="/home"><i className={`${styles["icon_nav_home"]} ${styles["icon_nav"]}`} />홈</NavLink>
					<NavLink to="/mydata"><i className={`${styles["icon_nav_mydata"]} ${styles["icon_nav"]}`} />마이데이터</NavLink>
					{/* <NavLink to="/life"><i className={`${styles["icon_nav_life"]} ${styles["icon_nav"]}`} />라이프</NavLink> */}
					<NavLink to="/recommend"><i className={`${styles["icon_nav_recommend"]} ${styles["icon_nav"]}`} />추천</NavLink>
					{/* <NavLink to="/fincar"><i className={`${styles["icon_nav_fincar"]} ${styles["icon_nav"]}`} />핀카</NavLink> */}
				</motion.nav>
			}
		</AnimatePresence>
	)
}

export default Nav
